import { combineReducers } from 'redux'
import login from './login/reducer'
import register from './register/reducer'
import email from './lookup-email/reducer'
import registrationData from './reg-details/reducer'
import ui from './ui/reducer'

const rootReducer = combineReducers({
  login,
  register,
  email,
  registrationData,
  ui,
})

export default rootReducer
